import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { match, P } from 'ts-pattern';
import { DescriptionList, Flex, Text, useId } from '@applyboard/crystal-ui';
import { formatDate, useTranslation } from '@applyboard/ui-utils';
import { Copyable } from "../../../../../components/Copyable";
import { assert } from "../../../../../utils/assert";
import { useApplicationStudent } from "../../../data/student";
import { SideBarDescriptionList } from "../SideBarDescriptionList";
import { IeltsVerificationButton } from "./IeltsVerificationButton";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ExamDetails = function ExamDetails(_ref) {
  var _student$profile$addi, _student$profile$addi2;
  var copyEnabled = _ref.copyEnabled,
    hiddenSections = _ref.hiddenSections;
  var _useTranslation = useTranslation('ExamDetails'),
    t = _useTranslation.t;
  var _useApplicationStuden = useApplicationStudent(),
    student = _useApplicationStuden.student;
  var testScores = student.profile.testScores;
  var gmat = (_student$profile$addi = student.profile.additionalQualifications) === null || _student$profile$addi === void 0 ? void 0 : _student$profile$addi.gmat;
  var gre = (_student$profile$addi2 = student.profile.additionalQualifications) === null || _student$profile$addi2 === void 0 ? void 0 : _student$profile$addi2.gre;
  var ieltsHeadingId = useId();
  var toeflHeadingId = useId();
  var pteHeadingId = useId();
  var duolingoEnglishHeadingId = useId();
  var englishExamDetails = match(testScores)["with"]({
    englishExamType: 'ielts',
    ielts: P.nonNullable
  }, function (_ref2) {
    var ielts = _ref2.ielts;
    assert(ielts.examDate, 'IELTS exam date is required');
    return _jsxs(_Fragment, {
      children: [_jsx(Text, {
        id: ieltsHeadingId,
        variant: "labelL",
        children: t('ieltsHeading')
      }), _jsxs(SideBarDescriptionList, {
        "aria-labelledby": ieltsHeadingId,
        children: [_jsx(DescriptionList.Term, {
          children: t('scores')
        }), _jsx(DescriptionList.Details, {
          children: _jsxs(Flex, {
            gap: 2,
            direction: "column",
            children: [_jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('overall'), ": ").concat(ielts.average)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('listening'), ": ").concat(ielts.listening)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('reading'), ": ").concat(ielts.reading)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('writing'), ": ").concat(ielts.writing)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('speaking'), ": ").concat(ielts.speaking)
              })
            })]
          })
        }), _jsx(DescriptionList.Term, {
          children: t('examDate')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: formatDate(ielts.examDate, 'MMM D, YYYY')
          })
        })]
      }), !(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('exams.ieltsVerification')) && _jsx(IeltsVerificationButton, {})]
    });
  })["with"]({
    englishExamType: 'toefl',
    toefl: P.nonNullable
  }, function (_ref3) {
    var toefl = _ref3.toefl;
    assert(toefl.examDate, 'TOEFL exam date is required');
    return _jsxs(_Fragment, {
      children: [_jsx(Text, {
        id: toeflHeadingId,
        variant: "labelL",
        children: t('toeflHeading')
      }), _jsxs(SideBarDescriptionList, {
        "aria-labelledby": toeflHeadingId,
        children: [_jsx(DescriptionList.Term, {
          children: t('scores')
        }), _jsx(DescriptionList.Details, {
          children: _jsxs(Flex, {
            gap: 2,
            direction: "column",
            children: [_jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('overall'), ": ").concat(toefl.total)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('listening'), ": ").concat(toefl.listening)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('reading'), ": ").concat(toefl.reading)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('writing'), ": ").concat(toefl.writing)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('speaking'), ": ").concat(toefl.speaking)
              })
            })]
          })
        }), _jsx(DescriptionList.Term, {
          children: t('examDate')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: formatDate(toefl.examDate, 'MMM D, YYYY')
          })
        })]
      })]
    });
  })["with"]({
    englishExamType: 'pte',
    pte: P.nonNullable
  }, function (_ref4) {
    var pte = _ref4.pte;
    assert(pte.examDate, 'PTE exam date is required');
    return _jsxs(_Fragment, {
      children: [_jsx(Text, {
        id: pteHeadingId,
        variant: "labelL",
        children: t('pteHeading')
      }), _jsxs(SideBarDescriptionList, {
        "aria-labelledby": pteHeadingId,
        children: [_jsx(DescriptionList.Term, {
          children: t('scores')
        }), _jsx(DescriptionList.Details, {
          children: _jsxs(Flex, {
            gap: 2,
            direction: "column",
            children: [_jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('overall'), ": ").concat(pte.total)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('listening'), ": ").concat(pte.listening)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('reading'), ": ").concat(pte.reading)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('writing'), ": ").concat(pte.writing)
              })
            }), _jsx(Text, {
              children: _jsx(Copyable, {
                disabled: !copyEnabled,
                children: "".concat(t('speaking'), ": ").concat(pte.speaking)
              })
            })]
          })
        }), _jsx(DescriptionList.Term, {
          children: t('examDate')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: formatDate(pte.examDate, 'MMM D, YYYY')
          })
        })]
      })]
    });
  })["with"]({
    englishExamType: 'duolingo_english',
    duolingoEnglish: P.nonNullable
  }, function (_ref5) {
    var duolingoEnglish = _ref5.duolingoEnglish;
    assert(duolingoEnglish.examDate, 'Duolingo English exam date is required');
    return _jsxs(_Fragment, {
      children: [_jsx(Text, {
        id: duolingoEnglishHeadingId,
        variant: "labelL",
        children: t('duolingoEnglishHeading')
      }), _jsxs(SideBarDescriptionList, {
        "aria-labelledby": duolingoEnglishHeadingId,
        children: [_jsx(DescriptionList.Term, {
          children: t('scores')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('overall'), ": ").concat(duolingoEnglish.total)
            })
          })
        }), _jsx(DescriptionList.Term, {
          children: t('examDate')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: formatDate(duolingoEnglish.examDate, 'MMM D, YYYY')
          })
        })]
      })]
    });
  }).otherwise(function () {
    return null;
  });
  if (!(englishExamDetails || gmat || gre)) {
    return _jsx(Text, {
      intent: "secondary",
      contrast: "mid",
      children: t('noExamsMessage')
    });
  }
  return _jsxs(Flex, {
    gap: 4,
    direction: "column",
    children: [englishExamDetails, _jsx(GmatDetails, {
      copyEnabled: copyEnabled
    }), _jsx(GreDetails, {
      copyEnabled: copyEnabled
    })]
  });
};
var GmatDetails = function GmatDetails(_ref6) {
  var _student$profile$addi3;
  var copyEnabled = _ref6.copyEnabled;
  var _useTranslation2 = useTranslation('ExamDetails'),
    t = _useTranslation2.t;
  var _useApplicationStuden2 = useApplicationStudent(),
    student = _useApplicationStuden2.student;
  var gmatHeadingId = useId();
  var gmat = (_student$profile$addi3 = student.profile.additionalQualifications) === null || _student$profile$addi3 === void 0 ? void 0 : _student$profile$addi3.gmat;
  if (!gmat) {
    return null;
  }
  assert(gmat.examDate, 'GMAT exam date is required');
  return _jsxs(_Fragment, {
    children: [_jsx(Text, {
      id: gmatHeadingId,
      variant: "labelL",
      children: t('gmatHeading')
    }), _jsxs(SideBarDescriptionList, {
      "aria-labelledby": gmatHeadingId,
      children: [_jsx(DescriptionList.Term, {
        children: t('scores')
      }), _jsx(DescriptionList.Details, {
        children: _jsxs(Flex, {
          gap: 2,
          direction: "column",
          children: [_jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('verbal'), ": ").concat(gmat.verbalScore, "/").concat(gmat.verbalRank, "%")
            })
          }), _jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('quantitative'), ": ").concat(gmat.quantitativeScore, "/").concat(gmat.quantitativeRank, "%")
            })
          }), _jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('total'), ": ").concat(gmat.totalScore, "/").concat(gmat.totalRank, "%")
            })
          }), _jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('analyticalWriting'), ": ").concat(gmat.writingScore, "/").concat(gmat.writingRank, "%")
            })
          })]
        })
      }), _jsx(DescriptionList.Term, {
        children: t('examDate')
      }), _jsx(DescriptionList.Details, {
        children: _jsx(Copyable, {
          disabled: !copyEnabled,
          children: formatDate(gmat.examDate, 'MMM D, YYYY')
        })
      })]
    })]
  });
};
var GreDetails = function GreDetails(_ref7) {
  var _student$profile$addi4;
  var copyEnabled = _ref7.copyEnabled;
  var _useTranslation3 = useTranslation('ExamDetails'),
    t = _useTranslation3.t;
  var _useApplicationStuden3 = useApplicationStudent(),
    student = _useApplicationStuden3.student;
  var greHeadingId = useId();
  var gre = (_student$profile$addi4 = student.profile.additionalQualifications) === null || _student$profile$addi4 === void 0 ? void 0 : _student$profile$addi4.gre;
  if (!gre) {
    return null;
  }
  assert(gre.examDate, 'GRE exam date is required');
  return _jsxs(_Fragment, {
    children: [_jsx(Text, {
      id: greHeadingId,
      variant: "labelL",
      children: t('greHeading')
    }), _jsxs(SideBarDescriptionList, {
      "aria-labelledby": greHeadingId,
      children: [_jsx(DescriptionList.Term, {
        children: t('scores')
      }), _jsx(DescriptionList.Details, {
        children: _jsxs(Flex, {
          gap: 2,
          direction: "column",
          children: [_jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('verbal'), ": ").concat(gre.verbalScore, "/").concat(gre.verbalRank, "%")
            })
          }), _jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('quantitative'), ": ").concat(gre.quantitativeScore, "/").concat(gre.quantitativeRank, "%")
            })
          }), _jsx(Text, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: "".concat(t('analyticalWriting'), ": ").concat(gre.writingScore, "/").concat(gre.writingRank, "%")
            })
          })]
        })
      }), _jsx(DescriptionList.Term, {
        children: t('examDate')
      }), _jsx(DescriptionList.Details, {
        children: _jsx(Copyable, {
          disabled: !copyEnabled,
          children: formatDate(gre.examDate, 'MMM D, YYYY')
        })
      })]
    })]
  });
};